
export const barneyMediaArray = [
  {
    _id: 'barneyMediaId1',
    userId: 'barneyUserId',
    email: 'barney@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-barney-1-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-barney-1-p.png`,
    description: ``,
    captions: [
      `My weekends look like`,
      `I can teach you how to`,
      `My best blue steel`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'barneyMediaId2',
    userId: 'barneyUserId',
    email: 'barney@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-barney-2-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-barney-2-p.png`,
    description: ``,
    captions: [
      `Woke up like this`,
      `Lowkey flex`,
      `Me in the wild`
    ],
    subcaptions: [
      `When your hockey team puts up a stinker`,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'barneyMediaId3',
    userId: 'barneyUserId',
    email: 'barney@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-barney-3-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-barney-3-p.png`,
    description: ``,
    captions: [
      `Plandid or candid?`,
      `Felt cute might delete later`,
      `I thought I deleted this one`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'barneyMediaId4',
    userId: 'barneyUserId',
    email: 'barney@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-barney-4-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-barney-4-p.png`,
    description: ``,
    captions: [
      `It was all fun and games until`,
      `How I fight the Sunday scaries`,
      `The advertisement for my life would look like`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'barneyMediaId5',
    userId: 'barneyUserId',
    email: 'barney@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-barney-5-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-barney-5-p.png`,
    description: ``,
    captions: [
      `Don't judge me`,
      `Caught in the act`,
      `#MondaysAmIRight?`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'barneyMediaId6',
    userId: 'barneyUserId',
    email: 'barney@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-barney-6-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-barney-6-p.png`,
    description: ``,
    captions: [
      `My good side`,
      `My best blue steel`,
      `I feel famous when`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'barneyMediaId7',
    userId: 'barneyUserId',
    email: 'barney@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-barney-7-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-barney-7-p.png`,
    description: ``,
    captions: [
      `My quarter life crisis looks like`,
      `My best blue steel`,
      `My life behind the scenes`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'barneyMediaId8',
    userId: 'barneyUserId',
    email: 'barney@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-barney-8-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-barney-8-p.png`,
    description: ``,
    captions: [
      `Life outtake`,
      `Plandid or candid?`,
      `My life behind the scenes`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'barneyMediaId9',
    userId: 'barneyUserId',
    email: 'barney@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-barney-9-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-barney-9-p.png`,
    description: ``,
    captions: [
      `Don't show this to my mom`,
      `Comment if you've been here`,
      `Most exotic place I've been`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'barneyMediaId10',
    userId: 'barneyUserId',
    email: 'barney@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-barney-10-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-barney-10-p.png`,
    description: ``,
    captions: [
      `How my friends see me`,
      `My weekends look like`,
      `How I fight the Sunday scaries`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'barneyMediaId11',
    userId: 'barneyUserId',
    email: 'barney@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-barney-11-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-barney-11-p.png`,
    description: ``,
    captions: [
      `A special talent of mine`,
      `Me and my best friend`,
      `I'm known for`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'barneyMediaId12',
    userId: 'barneyUserId',
    email: 'barney@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-barney-12-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-barney-12-p.png`,
    description: ``,
    captions: [
      `My vulnerable side`,
      `#MondaysAmIRight?`,
      `Life outtake`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'barneyMediaId13',
    userId: 'barneyUserId',
    email: 'barney@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-barney-13-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-barney-13-p.png`,
    description: ``,
    captions: [
      `My quarter life crisis looks like`,
      `Dating me will look like`,
      `The advertisement for my life would look like`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'barneyMediaId14',
    userId: 'barneyUserId',
    email: 'barney@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-barney-14-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-barney-14-p.png`,
    description: ``,
    captions: [
      `A special talent of mine`,
      `Me and my best friend`,
      `I'm known for`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'barneyMediaId15',
    userId: 'barneyUserId',
    email: 'barney@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-barney-15-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-barney-15-p.png`,
    description: ``,
    captions: [
      `My best blue steel`,
      `My uniform`,
      `The moment I knew my modeling career was over`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'barneyMediaId16',
    userId: 'barneyUserId',
    email: 'barney@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-barney-16-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-barney-16-p.png`,
    description: ``,
    captions: [
      `My best blue steel`,
      `My uniform`,
      `Me during Fashion Week`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'barneyMediaId17',
    userId: 'barneyUserId',
    email: 'barney@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-barney-17-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-barney-17-p.png`,
    description: ``,
    captions: [
      `My weekends look like`,
      `My life behind the scenes`,
      `The advertisement for my life would look like`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'barneyMediaId18',
    userId: 'barneyUserId',
    email: 'barney@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-barney-18-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-barney-18-p.png`,
    description: ``,
    captions: [
      `Help me identify this photo bomber`,
      `Me in my blogging days`,
      `Caught in the act`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'barneyMediaId19',
    userId: 'barneyUserId',
    email: 'barney@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-barney-19-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-barney-19-p.png`,
    description: ``,
    captions: [
      `Caught in the act`,
      `My weekends look like`,
      `How history will remember me`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'barneyMediaId20',
    userId: 'barneyUserId',
    email: 'barney@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-barney-20-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-barney-20-p.png`,
    description: ``,
    captions: [
      `Me and my best friend`,
      `My weekends look like`,
      `How my friends see me`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'barneyMediaId21',
    userId: 'barneyUserId',
    email: 'barney@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-barney-21-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-barney-21-p.png`,
    description: ``,
    captions: [
      `Lowkey flex`,
      `As seen on my Mom's fridge`,
      `Woke up like this`
    ],
    subcaptions: [
      ``,
      ``,
      ``
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  }
]